(() => {
  if (window.__gkCollectionFiltersBound) return;
  window.__gkCollectionFiltersBound = true;

  const collectionUpdateEvent = 'shopify:collection:update';
  const categorySelector = '[data-gk-category-filter]';
  const categoryParam = 'filter.p.product_type';
  const syncedCategorySelector = '[data-gk-category-sync]';
  const navigationLoadingKey = 'gk-collection-navigation-loading';
  const navigationPendingClass = 'gk-collection-navigation-pending';
  const navigationLoadingFallback = 5000;
  let activeRender = 0;
  let navigationLoadingFallbackTimer;

  const getResults = () => document.querySelector('.collection-page-results');

  const syncCategoryFiltersToFacetForms = () => {
    const values = [...new Set([...document.querySelectorAll(`${categorySelector}:checked`)].map((input) => input.value))];

    document.querySelectorAll('facets-form-component form').forEach((form) => {
      form.querySelectorAll(syncedCategorySelector).forEach((input) => input.remove());

      values.forEach((value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = categoryParam;
        input.value = value;
        input.setAttribute('data-gk-category-sync', 'true');
        form.append(input);
      });
    });
  };

  const setLoading = () => {
    const results = getResults();
    if (!results) return;

    results.setAttribute('data-gk-filter-loading', 'true');
    results.removeAttribute('data-gk-filter-ready');
  };

  const setReady = (renderId) => {
    if (renderId !== activeRender) return;

    const results = getResults();
    if (!results) return;

    results.removeAttribute('data-gk-filter-loading');
    results.setAttribute('data-gk-filter-ready', 'true');
  };

  const releaseNavigationLoading = () => {
    if (!window.__gkCollectionNavigationLoading) return;

    window.__gkCollectionNavigationLoading = false;
    document.documentElement.classList.remove(navigationPendingClass);
    window.clearTimeout(navigationLoadingFallbackTimer);
    setReady(activeRender);
  };

  const getCollectionPath = (url) => `${url.pathname}${url.search}`;

  const consumeNavigationLoading = () => {
    let pendingPath = null;

    try {
      pendingPath = window.sessionStorage.getItem(navigationLoadingKey);
      window.sessionStorage.removeItem(navigationLoadingKey);
    } catch {
      // The URL/class handoff below still supports the transition when storage is unavailable.
    }

    const hasPendingClass = document.documentElement.classList.contains(navigationPendingClass);
    if ((!pendingPath || pendingPath !== getCollectionPath(new URL(window.location.href))) && !hasPendingClass) return;

    window.__gkCollectionNavigationLoading = true;
    setLoading();
    navigationLoadingFallbackTimer = window.setTimeout(releaseNavigationLoading, navigationLoadingFallback);
  };

  document.addEventListener(collectionUpdateEvent, (event) => {
    const eventTarget = event.target;
    if (eventTarget instanceof Element && !eventTarget.closest('.collection-page-results')) return;

    const renderId = ++activeRender;
    setLoading();

    const renderPromise = event.promise;
    if (!renderPromise || typeof renderPromise.then !== 'function') {
      requestAnimationFrame(() => setReady(renderId));
      return;
    }

    Promise.resolve(renderPromise).then(
      () => requestAnimationFrame(() => {
        syncCategoryFiltersToFacetForms();
        requestAnimationFrame(() => {
          if (renderId !== activeRender) return;
          syncCategoryFiltersToFacetForms();
          setReady(renderId);
        });
      }),
      () => requestAnimationFrame(() => {
        syncCategoryFiltersToFacetForms();
        requestAnimationFrame(() => {
          if (renderId !== activeRender) return;
          syncCategoryFiltersToFacetForms();
          setReady(renderId);
        });
      })
    );
  });

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;

      if (input.matches(categorySelector) || input.name === 'sort_by' || input.name.startsWith('filter.')) {
        syncCategoryFiltersToFacetForms();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.gk-collection-filters__clear');
      if (!button) return;

      const target = button.closest('facet-remove-component')?.dataset.url;
      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(new URL(target, window.location.origin).href);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        consumeNavigationLoading();
        syncCategoryFiltersToFacetForms();
        requestAnimationFrame(syncCategoryFiltersToFacetForms);
      },
      { once: true }
    );
  } else {
    consumeNavigationLoading();
    requestAnimationFrame(() => {
      syncCategoryFiltersToFacetForms();
      requestAnimationFrame(syncCategoryFiltersToFacetForms);
    });
  }
})();
